// Reads in-person treatment center locations from the provider's own profile.
// The profile API (GET api/v1/profile) returns TreatmentCenters[] (plural) per
// visit type within each license. This hook deduplicates by TreatmentCenterId
// and returns a stable flat list for the location dropdown.
import { useMemo } from 'react'
import { useSelector } from 'store/hooks/useSelector'

export function useProviderLocations() {
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)

  const locations = useMemo(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    const allTreatmentCenters = (profile?.Licenses || []).flatMap((license) =>
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (license.VisitTypes || []).flatMap((visitType) => visitType.TreatmentCenters || []),
    )
    return [
      ...new Map(
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        allTreatmentCenters.map((treatmentCenter) => [treatmentCenter.TreatmentCenterId, treatmentCenter]),
      ).values(),
    ]
  }, [profile])

  return { locations, loading: false }
}
